import "./instrument";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import "./index.css";
import "./lib/i18n/i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nextProvider } from "react-i18next";
import i18n from "./lib/i18n/i18n";

import { Link, RouterProvider, createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";
import DefaultError from "./components/utility/DefaultError";

const queryClient = new QueryClient();
const router = createRouter({
    routeTree,
    context: {
        queryClient,
    },
    trailingSlash: "never",
    defaultNotFoundComponent: () => {
        return (
            <div className="flex flex-col items-center justify-center h-screen mt-4">
                <p>Not found!</p>
                <Link
                    to="/"
                    className="bg-primary-500 text-white px-4 py-2 rounded-md"
                >
                    Go back to home dashboard
                </Link>
            </div>
        );
    },
    defaultErrorComponent: () => <DefaultError />,
});

declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <QueryClientProvider client={queryClient}>
                <RouterProvider router={router} />
            </QueryClientProvider>
        </I18nextProvider>
    </React.StrictMode>,
);
